// composables/useDevice.js
import { ref, computed } from 'vue'

const DESKTOP_BREAKPOINT = 768

// ============================================================
// 全局单例（在模块加载时初始化）
// ============================================================
const windowWidth = ref(
  typeof window !== 'undefined' ? window.innerWidth : 1024
)

// 全局响应式属性
export const isDesktop = computed(() => windowWidth.value >= DESKTOP_BREAKPOINT)
export const isMobile = computed(() => windowWidth.value < DESKTOP_BREAKPOINT)

// 初始化监听
let resizeHandler = null
let isInitialized = false

export function initDeviceListener() {
  if (isInitialized) return
  isInitialized = true

  if (typeof window !== 'undefined') {
    resizeHandler = () => {
      windowWidth.value = window.innerWidth
    }
    window.addEventListener('resize', resizeHandler)
  }
}

// ============================================================
// useDevice hook（组件内使用，返回同样的全局属性）
// ============================================================
export function useDevice() {
  const isTablet = computed(() => {
    return windowWidth.value >= 600 && windowWidth.value < DESKTOP_BREAKPOINT
  })

  return {
    windowWidth,
    isDesktop,
    isMobile,
    isTablet,
    DESKTOP_BREAKPOINT,
  }
}